import { render, staticRenderFns } from "./notification-status-badge.vue?vue&type=template&id=aeda8230"
import script from "./notification-status-badge.vue?vue&type=script&lang=js"
export * from "./notification-status-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports